/**
 * Fetches the scenario catalogue from the server once on mount. The list
 * drives the scenario selector in the chat header and the per scenario knob
 * controls in settings, so it is lifted to the App level and shared rather
 * than fetched independently by each consumer.
 */

import { useEffect, useState } from 'react';

import type { ScenarioInfo } from './use-chat.ts';

export function useScenarios(): ScenarioInfo[] {
  const [scenarios, setScenarios] = useState<ScenarioInfo[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    fetch('/v1/scenarios', { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) return;
        const body = (await response.json()) as { scenarios: ScenarioInfo[] };
        setScenarios(body.scenarios);
      })
      .catch(() => {
        // The selector falls back to the default id; the first send will
        // surface a real error if the server is down.
      });
    return () => {
      controller.abort();
    };
  }, []);

  return scenarios;
}
